import NavLink from '../navLink'
import call from '../../images/footer/call.png'
import follow from '../../images/footer/follow.png'
import message from '../../images/footer/message.png'
import useMediaQuery from '../../hooks/useMediaQuery'
import { Col, Row } from 'antd'
import { useEffect, useState } from 'react'
import { BASE_URL, getFooter } from '../../api/api'

const Footer = () => {
  const [data, setData] = useState()
  const [footerLeft, setFooterLeft] = useState([])

  useEffect(() => {
    getFooter().then(res => {
      setData(res?.data)
      document.title = res?.data?.set?.name || ''
      setFooterLeft([
        { name: '电话', information: res?.data?.set?.tel?.split(' '), icon: call, type: 'tel' },
        {
          name: '媒体合作',
          information: res?.data?.set?.content?.split(' '),
          icon: follow,
          type: 'tel'
        },
        {
          name: '邮箱',
          information: res?.data?.set?.email?.split(' '),
          icon: message,
          type: 'mailto'
        }
      ])
    })
  }, [])

  const isMobile = useMediaQuery()

  const getUrl = (type, id, diyname = '') => {
    switch (type) {
      case 'page':
        return `/wzxq/id/${id}`
      case 'list':
        return `/hyjj/channel_id/${id}`
      case 'channel':
        return `/${diyname}/channel_id/${id}`
      default:
        return `/${diyname}/channel_id/${id}`
    }
  }

  if (isMobile) {
    return (
      <div className="px-5 py-10 bg-[#0189D5]">
        <Row>
          <Col span={10}>
            <div className="flex">
              <div className="text-white">
                {footerLeft.map(({ name, information, icon, type }) => (
                  <div key={name}>
                    <div className="flex items-center mb-2 mt-2">
                      <img style={{ width: 20, height: 20 }} src={icon} alt={name} />
                      <span className="ml-2">{name}</span>
                    </div>
                    {information.map(item => (
                      <div>
                        <NavLink to={`${type}:${item}`}>{item}</NavLink>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </Col>
          <Col span={4}>
            <div className="w-[2px] h-[180px] bg-white"></div>
          </Col>
          <Col span={10}>
            <img className="mt-2" src={`${BASE_URL}${data?.set?.code_image || ''}`} alt="" />
          </Col>
        </Row>
        <div className="text-center mt-[80px] text-white font-sourceHan text-xs">
          中国消费经济论坛 京ICP备15058293号-1
          <br />
          京公网安备 11010602130018号 <br /> Copyright© 1999-2023 中国消费经济论坛 版权所有
        </div>
      </div>
    )
  }

  return (
    <div className="w-full pt-[104px] bg-footerBanner bg-cover">
      <div className="max-w-1200 mx-auto">
        <div className="flex">
          <div className="text-white">
            {footerLeft.map(({ name, information, icon, type }) => (
              <div key={name}>
                <div className="flex items-center mb-2 mt-2">
                  <img style={{ width: 18, height: 18 }} src={icon} alt={name} />
                  <span className="ml-2">{name}</span>
                </div>
                {information.map(item => (
                  <div>
                    <NavLink to={`${type}:${item}`}>{item}</NavLink>
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div className="pl-[50px] w-full flex justify-start ml-[92px] border-l border-solid border-[#15ABFF] relative">
            {data?.tree?.map(({ name, type, children, id, diyname = '' }) => (
              <div key={name} className="flex flex-col ml-12">
                <NavLink
                  className="text-white mb-[34px] font-alhpr font-bold text-xl"
                  to={getUrl(type, id, diyname)}
                >
                  {name}
                </NavLink>
                {children.map(({ name: liName, type, id, diyname = '' }) => (
                  <NavLink
                    key={liName}
                    className="text-[#ACDFFD] mb-5 font-sourceHan"
                    to={getUrl(type, id, diyname)}
                  >
                    {liName}
                  </NavLink>
                ))}
              </div>
            ))}
            <img
              className=" absolute right-0 bottom-24"
              style={{ width: 74, height: 74 }}
              src={`${BASE_URL}${data?.set?.code_image || ''}`}
              alt=""
            />
          </div>
        </div>
        <div className="text-center border-t border-[#15ABFF] mt-[80px] py-[50px] text-white font-sourceHan">
          中国消费经济论坛 京ICP备15058293号-1 | 京公网安备 11010602130018号
          <br />
          Copyright© 1999-2023 中国消费经济论坛 版权所有
        </div>
      </div>
    </div>
  )
}

export default Footer
